export default "__VITE_ASSET__f539c551__"